
///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/bootstrap.multiselect.d.ts"/>
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
    templateUrl: './AppViews/BugTracker/BugTracker.html'
})

export class BugTrackerComponent implements OnInit {

    constants: Constants;
    issueDetails: any = [];
    isCommercialEdit: any = 0;
    userDetail: any;
    userDetailById: any
    showUsertab: boolean = false;
    addUpdateIssue: any = {};
    addUpdateIssueFormActive: any = true;
    public showLoader = false;
    projects: any = [];
    IssueModuleList: any = [];
    severityItems: any = [];
    priorityItems: any = [];
    statusItems: any = [];
    catagoryItems: any = [];
    users: any = [];
    issueItems: any = [];
    public isAddUpdateIssueFormSubmitted: boolean = false;
    public isFormSubmitted: boolean = false;
    projectItems: any = [];
    issueStatusItems: any = [];
    issueStageItems: any = [];
    issuePriorityItems: any = [];
    issueCatagoryItems: any = [];
    issueSeverityItems: any = [];
    issueAssigneeItems: any = [];
    issueReporterItems: any = [];
    updateIssue: any = {};
    reportedDate: number = 0;
    isEditableStatus: boolean = false;
    isEditableForAssignee: boolean = false;
    isEditableForStatus: boolean = false;
    isEditableForReporter: boolean = false;
    isEditableIssue: boolean = true;
    isEditable: boolean = true;
    fileList: any = [];
    remarkListItems: any = [];
    Screeshot: any =[];
    UserReportedBy:String;
    previousIssueDetails:any = [];
    ScreenshotPath:any;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe, private route: ActivatedRoute, private _route: Router) {
        this.route
            .params
            .subscribe(
            data => {
                this.issueDetails.IssueId = data["IssueId"];
                this.isCommercialEdit = data["Com"];
            }
            );
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        
        
      
        if (this.issueDetails.IssueId != 0) {
            this.getIssuedetails();
           
            
           
        }
        if (this.issueDetails.IssueId == 0) {
          this.getPreviousIssueDetails();
          this.addUpdateIssue = {'IssueTitle' :"",'Description':"",'StatusId': 1,'PriorityId':2, 'ProjectId': "",'ModuleId':"", 'CategoryId': 1, 'ReportedBy': "", 'SeverityId': 2, 'AssignedTo': "" ,'Remark':null,'PageURL':""};
            this.addUpdateIssue.ReportedBy=this.userDetail.SiteUserId;
            this.UserReportedBy= this.userDetail.Name; 
              this.isEditable = false;
              this.isEditableIssue  = false;
            
        }
        
    }
    ngOnInit() {

        
        this.bindDropdownsData();
        // if (this.issueDetails.IssueId != 0) {
        //    this.getIssuedetails();
        //}
    }


    bindDropdownsData() {
        this.showLoader = true;
      

        this._httpService.ajaxPost('BugTracker/GetAssignedProjectByUserId', { "UserId": this.userDetail.SiteUserId }).subscribe(
            data => {

                this.projectItems = data["AssignedProjectList"];

            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = true;
                this._httpService.ajaxPost('Common/GetParameter',
                    { "ParameterTypeId": this.constants.enumParamterTypeName["IssueSeverity"] }).subscribe(
                    data => {
                        this.issueSeverityItems = data["Parameter"];
                    },
                    err => {
                        this.showLoader = false;
                    },

                    () => {
                        this.showLoader = true;
                        this._httpService.ajaxPost('Common/GetParameter',
                            { "ParameterTypeId": this.constants.enumParamterTypeName["IssuePriority"] }).subscribe(
                            data => {
                                this.issuePriorityItems = data["Parameter"];
                            },
                            err => {
                                this.showLoader = false;
                            },
                            () => {
                                this.showLoader = true;
                                 
                                this._httpService.ajaxPost('Common/GetParameter',
                                    { "ParameterTypeId": this.constants.enumParamterTypeName["IssueStatus"] }).subscribe(
                                    data => {
                                         
                                        if(this.issueDetails.IssueId==0)
                                        {
                                         this.issueStatusItems = data["Parameter"];
                                         
                                          
                                        }
                                        else if((this.issueDetails.IssueId!=0)&&(this.addUpdateIssue.StatusId!=1)){
                                          this.issueStatusItems = data["Parameter"];
                                          this.issueStatusItems =this.issueStatusItems.filter(item => item.Value != 1);
                                        }
                                        else if((this.issueDetails.IssueId!=0)&&(this.addUpdateIssue.StatusId==1)) {
                                         
                                          this.isEditableForStatus= true;
                                          this.issueStatusItems = data["Parameter"];

                                        }
                                        else{
                                             this.issueStatusItems = data["Parameter"];
                                        }

                                    },
                                    err => {
                                        this.showLoader = false;
                                    },
                                    () => {
                                        this.showLoader = true;
                                        this._httpService.ajaxPost('Common/GetParameter',
                                            { "ParameterTypeId": this.constants.enumParamterTypeName["IssueCategory"] }).subscribe(
                                            data => {
                                                this.issueCatagoryItems = data["Parameter"];


                                            },
                                            err => {
                                                this.showLoader = false;
                                            },
                                            () => {
                                                this.showLoader = true;
                                                this._httpService.ajaxPost('BugTracker/GetUser').subscribe(
                                                    data => {
                                                        this.issueAssigneeItems = data["UserList"];

                                                       // this.issueReporterItems = data["UserList"];
                                                    },
                                                    err => {

                                                      
                                                        this.showLoader = false;
                                                    },
                                                    () => {
                                                        this.showLoader = false;
                                                    }

                                                ); this.showLoader = false;

                                            }); this.showLoader = false;

                                    }); this.showLoader = false;

                              }); this.showLoader = false;

                    }); this.showLoader = false;


            });
    }
    public getIssuedetails() {
        this.showLoader = true;
        this._httpService.ajaxPost("BugTracker/GetIssueDetails", { "IssueId": this.issueDetails.IssueId }).subscribe(
            data => {
                // if(data["IssueItems"] != null)
                 
                this.addUpdateIssue = data["Issuelist"][0];
                 
                this.GetModule(this.addUpdateIssue.ProjectId,null);
                this.ScreenshotPath =data["Path"];
                if(this.addUpdateIssue.Screeshot!=null){
                this.Screeshot =data["Path"]+ "Documents/" +  this.addUpdateIssue.Screeshot;
                }
                
                if (this.addUpdateIssue.AssignedTo==this.userDetail.SiteUserId|| this.addUpdateIssue.ReportedBy==this.userDetail.SiteUserId) {
                    
                    this.isEditableIssue = false;

                  }

               
                  
                if ((this.addUpdateIssue.AssignedTo == null) && (this.addUpdateIssue.ReportedBy == this.userDetail.SiteUserId)&&(this.addUpdateIssue.StatusId==1)) {
                    
                    this.isEditableForReporter = false;
                }
                else {
                    this.isEditableForReporter = true;
                }

                if (this.addUpdateIssue.AssignedTo == this.userDetail.SiteUserId) {

                    this.isEditableForAssignee = false;
                    //this.isEditableForStatus = false;
                    

                }
                else {

                   this.isEditableForAssignee = true;
                   
                }

                if (this.userDetail.RoleId == 2 || this.userDetail.RoleId == 1) {
                    
                    this.isEditableStatus = false;
                    this.isEditableForAssignee = false;
                    this.isEditableForStatus = false;
                    this.isEditableIssue = false;
                    this.isEditableForReporter = false;

                }
                if( this.addUpdateIssue.StatusId==1)
               { this.isEditable = false; }
               if( this.addUpdateIssue.StatusId==2)
               { this.isEditable = false; }
                
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = true;
                this._httpService.ajaxPost("BugTracker/GetIssueRemarkDetails", { "IssueId": this.issueDetails.IssueId }).subscribe(
                    data => {
                     
                        this.remarkListItems = data["RemarkListItems"];
                    },
                    err => {
                        this.showLoader = false;

                    }); this.showLoader = false;

                     this._httpService.ajaxPost('BugTracker/GetUserbyId',{ "UserId": this.addUpdateIssue.ReportedBy }).subscribe(
                                                    data => {
                                                        this.userDetailById =data["UserList"][0];
                                                         
                                                        this.UserReportedBy = this.userDetailById.Name;
                                                         
                                                    },
                                                    err => {

                                                        this.showLoader = false;
                                                    },
                                                    () => {
                                                        this.showLoader = true;
                                                    }
                                                    );

                                                    console.log("werty"+this.addUpdateIssue.ReportedBy+JSON.stringify(this.addUpdateIssue));

            }

        );
    }
public CancelScreanShot() {
 
        $('#ViewScreanShot').modal('hide');
  
    }  

changeStatus(AssignedToId){


 
if((AssignedToId !="")&&( this.addUpdateIssue.StatusId==1)){
    
    this.addUpdateIssue.StatusId=2;
    this.showLoader = false;
    this.isEditableForStatus= false;
    this.issueStatusItems =this.issueStatusItems.filter(item => item.Value != 1);


}
else if((AssignedToId =="")&&(this.issueDetails.IssueId == 0))
{
    
     this.addUpdateIssue.StatusId=1;
      this.showLoader = false;

}

    this.showLoader = false;

}
    GetModule(ProjectId,from) {


       
        this.showLoader = true;

        
        this._httpService.ajaxPost("ProjectModule/GetProjectModule",
            { "ProjectId": ProjectId }).subscribe(
            data => {
                if(from == 1) 
               { this.addUpdateIssue.ModuleId="";
            }
                  if(data["ProjectModuleList"].length >0){
                this.IssueModuleList = data["ProjectModuleList"];
                  }
                  else{
                       let objItem: any = {};
                   
                    objItem.ProjectId = ProjectId;
                    objItem.ModuleName = "Main";;
                  //  objItem.ModuleId =0;
                   
             this._httpService.ajaxPost('ProjectModule/AddUpdateProjectModule',objItem).subscribe(
            data => {

                this.GetModule(ProjectId,null);
                 this.addUpdateIssue.ModuleId="";
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
        );
                  }
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }

            );
           

    }

    fileEvent(event) {
         //$('#ScreenshotTag').modal('hide');
        
        this.showLoader = true;

        let file: File = (event.target).files[0];
        this.fileList = (event.target).files;
        this.addUpdateIssue.Screenshot = file.name;
                              
        this._httpService.ajaxPostFile('BugTracker/AddUpdateFile', this.fileList).then((response) => {
           
            if(response["Status"]!=null){
            this.addUpdateIssue.Screeshot = response["Status"];
            this.Screeshot =this.ScreenshotPath+ "Documents/" +  this.addUpdateIssue.Screeshot;
            }
            this.showLoader = false;

        },(error) => {
        //FAILURE
         this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
    }
        
        );this.showLoader = false;
    }
    DeleteIssueTab(form: any) {

         $('#deleteIssue').modal('hide');
        this.showLoader = true;
        
            this._httpService.ajaxPost('BugTracker/DeleteIssue', { "IssueId": this.addUpdateIssue.IssueId }).subscribe(
                data => {
                    this._sharedService.ShowMessage(data["Status"].Message);
                    this._route.navigateByUrl("/bugTracker");
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                    this.showLoader = false;
                }
            );

        
       
    }
    AddUpdateIssueTab(form: any) {
        this.isAddUpdateIssueFormSubmitted = true;
        this.addUpdateIssue.SiteUserId = this.userDetail.SiteUserId;
      //p this.addUpdateIssue.ReportedBy=this.userDetail.SiteUserId;
        if (form.form.valid) {
            if (this.issueDetails.IssueId == 0) {

                this.showUsertab = true;
                this.addUpdateIssue.ReportedDate=new Date();
                
               
                this.addUpdateIssue.IssueId = this.issueDetails.IssueId;
            }
            else {
                this.addUpdateIssue.IssueId = this.issueDetails.IssueId;
               
                this.showUsertab = true
            }

            this.showLoader = true;

             if(this.addUpdateIssue.StatusId==2){
                   this.addUpdateIssue.AssignedDate=new Date(); 
                }
            if(this.addUpdateIssue.StatusId==3){
                   this.addUpdateIssue.FixedDate=new Date();
                }
            if(this.addUpdateIssue.StatusId==4){
                   this.addUpdateIssue.ClosedDate=new Date();
                }
                if(this.addUpdateIssue.StatusId==5){
                   this.addUpdateIssue.AssignedDate=new Date();
                }
console.log("this.addUpdateIssue:"+this.addUpdateIssue);
            this._httpService.ajaxPost('BugTracker/AddUpdateIssue', this.addUpdateIssue).subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                   
                    if (msg.length >= 1) {

                        msg[0] = msg[0].toLowerCase();
                        if (msg[0] == "success") {
                            this._route.navigateByUrl("/bugTracker");
                            this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                        }
                        else if (msg[0] == "warning") {
                            this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                        }
                        else {
                            this._route.navigateByUrl("/bugTracker");
                            this._sharedService.ShowMessage(this.constants.globalError);
                        }
                    }
                    else {
                    }
                },
                err => {
                    this.showLoader = false;
                    this._route.navigateByUrl("/bugTracker");
                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                    this.showLoader = false;
                }
            );
        } else {

            this._sharedService.ShowMessage("warning|Mandatory Fields are Missing");
        }
    }
getPreviousIssueDetails()
{
 this.showLoader = true;
        this._httpService.ajaxPost("BugTracker/GetPreviousIssueDetails", { "UserId":this.userDetail.SiteUserId }).subscribe(
            data => {
                // if(data["IssueItems"] != null)
                                this.showLoader = true;

                this.previousIssueDetails=data["IssueListItems"][0];              
                this.addUpdateIssue.ProjectId=this.previousIssueDetails.ProjectId;
                this.GetModule(this.addUpdateIssue.ProjectId,null);
                this.addUpdateIssue.ModuleId=this.previousIssueDetails.ModuleId;
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = true;
               

            }

        );
}



}



/** WEBPACK FOOTER **
 ** ./TypeScripts/BugTracker/BugTracker.component.ts
 **/